import { spawn } from 'redux-saga/effects'
import bookingSaga from './booking-requests.saga'

export default function*() {
  yield [spawn(bookingSaga)]
}
